"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_i18next_1 = require("react-i18next"); // assuming you are using react-i18next for translations
var useAdditionalField = function () {
    var i18n = (0, react_i18next_1.useTranslation)().i18n;
    var additionalFieldTranslations = (0, react_1.useCallback)(function (fieldMeta) {
        var _a, _b;
        // @ts-ignore
        var translations = (_b = (_a = fieldMeta === null || fieldMeta === void 0 ? void 0 : fieldMeta.extra) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.translations;
        if (translations && typeof translations === "object") {
            return translations[i18n.language];
        }
        else {
            return false;
        }
    }, [i18n.language]);
    var filter = (0, react_1.useCallback)(function (fieldMeta, keyName) {
        if (keyName === void 0) { keyName = "register"; }
        if (Array.isArray(fieldMeta.extra)) {
            return fieldMeta.extra.some(function (item) {
                return item && (item[keyName] === undefined || item[keyName] === true);
            });
        }
        return false;
    }, []);
    return {
        getFieldTranslations: additionalFieldTranslations,
        filterByKey: filter,
    };
};
exports.default = useAdditionalField;
